export const FEATURE_CATEGORIES = [
  {
    id: 'controls',
    features: [
      { featureId: 'control_submitted' },
      { featureId: 'report_exported' },
      { featureId: 'email_sent' },
    ],
  },
  {
    id: 'resources',
    features: [
      { featureId: 'resource_created' },
      { featureId: 'import_batch', comingSoon: true },
    ],
  },
  {
    id: 'ai',
    comingSoon: true,
    features: [
      { featureId: 'textract_run' },
      { featureId: 'stt_run' },
    ],
  },
];

const FEATURE_TO_CATEGORY = FEATURE_CATEGORIES.reduce((acc, cat) => {
  cat.features.forEach((f) => {
    acc[f.featureId] = cat.id;
  });
  return acc;
}, {});

export function getCategoryForFeature(featureId) {
  return FEATURE_TO_CATEGORY[featureId] || 'other';
}

export function groupFeaturesByCategory(features) {
  return FEATURE_CATEGORIES.reduce((acc, cat) => {
    acc[cat.id] = cat.features.map((featDef) => {
      const match = features.find((f) => f.featureId === featDef.featureId);
      return {
        featureId: featDef.featureId,
        comingSoon: !!featDef.comingSoon,
        runCount: (match && match.runCount) || 0,
        creditsConsumed: (match && match.creditsConsumed) || 0,
      };
    });
    return acc;
  }, {});
}
